import './App.css';
import Footer from './components/Footer/Footer';
import Hero from './components/Hero/Hero'
import Join from './components/Join/Join';
import Plans from './components/Plans/Plans';
import Programs from './components/Programs/Programs';
import Testimonials from './components/Testimonials/Testimonials';
import Video from "./components/Video/Video";
function App() {
  return (
    <div className="App">
      <Hero/>
      <Programs/>
      <Video/>
      <Plans/>
      <Testimonials/>
      <Join/>
      <Footer/>
          {/* <span style={{color: 'white'}}>Subscribe Zainkeepscode</span> */}
    </div>
  );
}

export default App;
